import { render, staticRenderFns } from "./PaymentSummary.vue?vue&type=template&id=06ee4439&"
import script from "./PaymentSummary.vue?vue&type=script&lang=ts&"
export * from "./PaymentSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports